export default "__VITE_ASSET__iHCH5mhM__"